<template>
  <div id="TemporaryStorage" class="full-height">
    <div class="row container-crud q-pa-md">
      <jt-dynamic-form
        ref="dynamicForm"
        :inputs="elements[0].inputs"
        :relacionamentos="elements[0].relacionamentos"
        :model="elements[0].dadosForm"
        :interface="elements[0].nmInterface"
        form-class="form dynamic"
        @search-found="onSearchFound"
      />
    </div>
    <div class="row full-width justify-center q-py-md">
      <div class="col-3 q-pr-sm">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="`${button}-${i}`"
        class="col-3"
        :class="i === forms[0].buttons.length - 1 ? 'q-pl-sm' : 'q-px-sm'"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  name: 'TemporaryStorage',
  mixins: [
    page
  ],
  components: {
    JtDynamicForm
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
export default class TemporaryStorage extends Vue {
  async onSearchFound ({ person: { idField: personId } }) {
    if (personId) {
      const { registros: records } = await repository.resolveDatatableModel('person.hql', {
        grid: 'findDocumentInformationsByPersonId',
        personId: parseInt(personId)
      })
      if (records.length > 0) {
        const firstRecord = records[0]
        Object.keys(firstRecord).forEach(key => {
          this.$set(this.elements[0].dadosForm, key, firstRecord[key])
        })
        this.$forceUpdate()
      }
    } else {
      Object.keys(this.elements[0].dadosForm).forEach(key => {
        this.$set(this.elements[0].dadosForm, key, null)
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#TemporaryStorage {
}
</style>
